import getDaysDiff from './getDaysDiff'

export default getDaysDiff
